import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, KeyRound, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function ChangePassword() {
  const nav = useNavigate();
  const { user, changePassword } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (next.length < 6) { setErr("La nuova password deve avere almeno 6 caratteri."); return; }
    if (next !== confirm) { setErr("Le due password non coincidono."); return; }
    setLoading(true);
    try {
      await changePassword(current, next);
      toast.success("Password aggiornata!");
      nav("/dashboard", { replace: true });
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Errore nel cambio password");
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return (
      <div className="page-bg min-h-[60vh] flex items-center justify-center">
        <div className="card-elevated p-8 text-[#5A6A94]">Devi effettuare il login prima.</div>
      </div>
    );
  }

  return (
    <div className="page-bg min-h-[70vh] flex items-center justify-center px-4 py-14">
      <div className="card-elevated p-8 max-w-md w-full fade-up">
        <div className="w-12 h-12 rounded-xl brand-blue-bg text-white flex items-center justify-center mx-auto mb-3">
          <KeyRound size={22} />
        </div>
        <h1 className="font-display font-extrabold text-2xl text-[#0B3D91] text-center" data-testid="change-pw-title">Cambia la tua password</h1>
        {user.must_change_password && (
          <p className="mt-2 text-sm text-[#F97316] font-semibold text-center" data-testid="change-pw-first-login-notice">
            È il tuo primo accesso. Imposta una password personale.
          </p>
        )}
        <p className="mt-1 text-sm text-[#5A6A94] text-center">Matricola: <strong className="font-mono">{user.matricola}</strong></p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="block text-sm font-semibold text-[#0F1E3D] mb-1.5">Password attuale</label>
            <input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)}
              className="warm-input" data-testid="input-current-password" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-[#0F1E3D] mb-1.5">Nuova password</label>
            <input type="password" required minLength={6} value={next} onChange={(e) => setNext(e.target.value)}
              className="warm-input" data-testid="input-new-password" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-[#0F1E3D] mb-1.5">Conferma nuova password</label>
            <input type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="warm-input" data-testid="input-confirm-password" />
          </div>
          {err && <p className="text-sm text-[#F97316]" data-testid="change-pw-error">{err}</p>}
          <button type="submit" disabled={loading} className="btn-primary w-full !py-3" data-testid="change-pw-submit">
            {loading ? <><Loader2 className="animate-spin" size={16} /> Attendere...</> : <><CheckCircle2 size={16} /> Aggiorna password</>}
          </button>
        </form>
      </div>
    </div>
  );
}
